import { render, staticRenderFns } from "./shopCodeIndex.vue?vue&type=template&id=54e11515"
import script from "./shopCodeIndex.vue?vue&type=script&lang=js"
export * from "./shopCodeIndex.vue?vue&type=script&lang=js"
import style0 from "./shopCodeIndex.vue?vue&type=style&index=0&id=54e11515&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports